import Icon from '@vfz/ui/dist/components/icon/icon';
import { VZButton } from 'components/Button/button.styles';
import { Modal } from 'components/Modal';
import { ModalButtons, ModalIcon } from 'components/Modal/modal.styles';
import { PiiMask } from 'components/PiiMask';
import { content } from 'pages/Products/pages/InternetProducts/pages/EmailSettings/components/SectionEmail/section-email.content';
import React from 'react';
import { ContentUtil } from 'utils/content';

const contentUtil = new ContentUtil({ content, componentName: 'SectionEmail' });

interface IRemovalSuccessModalProps {
  isCeasedCustomer?: boolean;
  emailAddress: string;
  onClose(): void;
}

export const RemovalSuccessModal = ({ isCeasedCustomer = false, emailAddress, onClose }: IRemovalSuccessModalProps) => (
  <Modal onClose={onClose}>
    <section data-testid="modal-removal-success">
      <ModalIcon>
        <Icon name="inboxUpload" />
      </ModalIcon>
      <h4>{contentUtil.translate('removalSuccessModal.header')}</h4>
      <PiiMask>{contentUtil.translateHtml('removalSuccessModal.content', { emailAddress })}</PiiMask>
      <ModalButtons>
        <VZButton to={isCeasedCustomer ? '/overzicht' : '/producten/internet#email'}>
          {contentUtil.translate('removalSuccessModal.button')}
        </VZButton>
      </ModalButtons>
    </section>
  </Modal>
);
